<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form @keyup.enter.native="getTableList"  class="com-search-box" :model="form" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="项目名称 :">
              <el-input v-model="form.projectName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="年度 :">
              <el-date-picker v-model="form.year" value-format="yyyy" type="year" placeholder="选择年">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm('form')">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;创建新项目
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="projectName" label="项目名称" min-width="8%" show-overflow-tooltip>
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleProjectSub(scope.row)">{{scope.row.projectName}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="planTime" label="项目开始时间" min-width="11%"></el-table-column>
          <el-table-column prop="planPeriod" label="项目周期" min-width="8%"></el-table-column>
          <el-table-column prop="projectType" label="项目类型" min-width="10%" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.projectType | filterProjectType(that)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="planPlace" label="地点" min-width="13%"></el-table-column>
          <el-table-column prop="planDept" label="部门" min-width="8%"></el-table-column>
          <el-table-column prop="charge" label="负责人" min-width="7%"></el-table-column>
          <el-table-column prop="creater" label="参与人" min-width="7%"></el-table-column>

          <!-- 操作 -->
          <!-- <el-table-column fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleAdd('edit', scope.row.projectId)">编辑</a>
            </template>
          </el-table-column> -->
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
    <!-- 新建项目 -->
    <cmp-pro-add ref="dialogProAdd"></cmp-pro-add>
  </div>
</template>

<script>
import cmpProAdd from './dialog/dialog-project-add' // 新建项目

export default {
  components: {
    cmpProAdd

  },
  data() {
    return {
      that: this,
      form: {
        projectName: '',
        year: '',
      },
      typeList: [],
      statusList: [],
      projectTypeList: [],
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      chooseRowIds: '' // 当前导出选中藏品id
    }
  },

  filters: {
    filterProjectType(type, that) {
      let obj = that.projectTypeList.filter(item => {
        return item.dictCode == type
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return type
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.$http.get('/project/getProjectList', {
        ...this.form,
        type: '1',
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          this.tableData = res.result
          this.total = res.page.allRow
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: ['activity_type', 'activity_status', 'project_type']
        })
        .then(res => {
          if (res.success) {
            var state = res.result
            let firstArr = [{ dictCode: null, dictName: '全部' }]
            this.typeList = firstArr.concat(state['activity_type'])
            this.statusList = firstArr.concat(state['activity_status'])
            this.projectTypeList = firstArr.concat(state['project_type'])
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 重置查询
    resetForm(formName) {
      this.form = {
        projectName: '',
        year: '',
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 新增
    handleAdd(operator, id) {
      this.$refs.dialogProAdd.init(operator, id)
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    handleProjectSub(row) {
      this.$router.push({
        path: '/project/sub',
        query: { type: 'task', projectId: row.projectId, projectName: row.projectName, projectType: '1' }
      })
    },
  },
  created() {
    this.getData()
    this.getDropdownValue()
  }
}
</script>

<style lang="scss" scoped>
.page-activity-manage {
  .nav-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .nav-item {
      margin-bottom: 10px;
      padding: 5px 10px;
      color: $color6;
      font-size: 14px;
      border: solid 1px $border;
      border-radius: 4px;
      margin-right: 20px;
      cursor: pointer;
      &.active {
        background-color: $primary;
        color: #fff;
        border-color: $primary;
      }
    }
  }

  /deep/ .el-table__row {
    cursor: pointer;
  }
}
</style>